// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import { makeServiceRequest } from '../ServiceRequest';
import type RequestOptions from '../RequestOptions';
import type CreateAttachmentJsonRequest from '../contract/CreateAttachmentJsonRequest';
import type CreateAttachmentJsonResponse from '../contract/CreateAttachmentJsonResponse';
import createAttachmentJsonRequest from '../factory/createAttachmentJsonRequest';

export default function createAttachmentFromLocalFileOperation(
    req: CreateAttachmentJsonRequest,
    options?: RequestOptions
): Promise<CreateAttachmentJsonResponse> {
    if (req !== undefined && !req['__type']) {
        req = createAttachmentJsonRequest(req);
    }

    return makeServiceRequest<CreateAttachmentJsonResponse>(
        'CreateAttachmentFromLocalFile',
        req,
        options
    );
}
